var ProfilePageController = require("app/ProfilePage/PageController"),
    RequireLoggedInUser   = require("app/core/middleware/RequireLoggedInUser"),
    ResolveLanguage       = require("app/core/middleware/ResolveLanguage"),
    RouteHandler          = require("app/core/RouteHandler"),
    kind                  = require("enyo/kind");

module.exports = [{

    /**
     * Profile Page
     *
     * @type {RegExp}
     */
    pattern: /^\/([a-z]{2})\/profile$/,

    /**
     * @type {app.core.RouteHandler}
     */
    Handler: kind({

        /**
         * @private
         */
        kind: RouteHandler,

        /**
         * @private
         */
        middleware: [
            ResolveLanguage,
            RequireLoggedInUser
        ],

        /**
         * Handler for the route
         *
         * @param  {app.core.App}  app  The application core
         * @public
         */
        execute: function(app) {
            var $mediaPlayerManager = app.$.mediaPlayerManager,
                language            = app.$.i18nService.get("language");

            app.$.header.set("showBackButton", true);

            app.activatePage(ProfilePageController, {
                language: language
            }, true);

            app.$.analyticsService.sendPageView({
                language: language
            });

            app.deactivateMediaDetails();

            app.$.state.get("mediaPlayerReady") === 1
                ? $mediaPlayerManager.setMediaPlayerDisplayMode("minimized")
                : $mediaPlayerManager.deactivateMediaPlayer();

            this.finish();
        }
    })
}];
